import { inject, InjectionToken } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { environment } from '../../environments/environment';
import type { AppRole } from './finlex.models';
import { AuthSessionService } from './auth-session.service';
import { cognitoLoginUrl } from './cognito-login';
import { ExternalNavigation } from './external-navigation.service';

const APPLICATION_ROLES = ['user', 'admin'] as const satisfies readonly AppRole[];

export const USER_ROUTE_GUARD_ENABLED = new InjectionToken<boolean>('USER_ROUTE_GUARD_ENABLED', {
  providedIn: 'root',
  factory: () => environment.userRouteGuardEnabled,
});

export const anyRoleGuard: CanActivateFn = async (_route, routerState) => {
  if (!inject(USER_ROUTE_GUARD_ENABLED)) {
    return true;
  }
  const session = inject(AuthSessionService);
  const router = inject(Router);
  const navigation = inject(ExternalNavigation);
  await session.whenReady();
  const state = session.state();
  if (state.status === 'authenticated') {
    return APPLICATION_ROLES.some((role) => state.principal.roles.includes(role))
      ? true
      : router.createUrlTree(['/ei-oikeutta']);
  }
  navigation.assign(cognitoLoginUrl(routerState.url));
  return false;
};
